<template>
  <div>
    <ListLegend
      :legends="tableLegends"
      :legendsFlexStructure="legendsFlexStructure"
    />
    <div v-for="(historyLog, index) in getHistory.history" :key="index" class="history-list-item">
      <div class="history-attribute-position">
        <img
          v-if="historyLog.longitude && historyLog.latitude"
          :id="`history-attribute-position-img-${index}`"
          alt="map-marker"
          :src="require(`@/assets/images/map-marker.svg`)"
          @click="displayMapModal(historyLog)"
        >
      </div>
      <div :id="`history-attribute-timestamp-${index}`" class="history-attribute-timestamp">{{ formatDateTimeSecond(historyLog.timestamp) }}</div>
      <div class="history-list-item-wrapper elevation-3 pa-2">
        <div :id="`history-attribute-device-id-${index}`" class="history-attribute">{{ historyLog.shortDeviceId }}</div>
        <div :id="`history-attribute-dtco-id-${index}`" class="history-attribute">{{ historyLog.dtcoId }}</div>
        <div :id="`history-attribute-type-${index}`" class="history-attribute history-attribute-type">{{ guessDeviceType(historyLog.deviceId) }}</div>
        <div class="history-attribute">
          <v-chip
            :id="`history-attribute-chip-${index}`"
            class="history-attribute-chip"
            :class="`history-attribute-chip-${historyLog.operation}`"
            dark
            small
          >
            {{ $t(`device.history.${historyLog.operation}`) }}
          </v-chip>
        </div>
        <div class="history-attribute">
          <v-icon
            :id="`history-attribute-category-${index}`"
            small
            class="mr-0"
            :class="`history-attribute-category-${historyLog.category || 'unknown'}`"
          >
            mdi-circle
          </v-icon>
          {{ $t(`device.history.${formatCategoryToCategoryKey(historyLog.category || 'unknown', '_')}`) }}
        </div>
        <div class="history-attribute history-attribute-subcategory">
          <span v-if="historyLog.subCategory" :id="`history-attribute-subcategory-${index}`">{{ $t(`device.history.${historyLog.subCategory}`) }}</span>
        </div>
        <div class="history-attribute details">
          <span :id="`history-attribute-platenumber-${index}`">{{ historyLog.plateNumber }}</span>
          <v-icon
            v-if="historyLog.payload"
            :id="`history-attribute-payload-${index}`"
            :title="$t(`device.history.modal_details.title.${historyLog.operation}`)"
            @click="displayDetailsModal(historyLog)"
          >
            mdi-information-outline
          </v-icon>
        </div>
      </div>
    </div>
    <HistoryMap
      v-if="mapModal"
      :enabled="mapModal"
      :marker="mapMarker"
      :history="selectedHistory"
      @close="displayMapModal"
    />
    <HistoryDetails
      v-if="detailsModal"
      :enabled="detailsModal"
      :history="selectedHistory"
      @close="displayDetailsModal"
    />
  </div>
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator';
import Utils from '@/mixins/Utils';
import { HistoryInner, InlineResponse200 } from 'ctp-history-service';
import ListLegend from '@/components/common/ListLegend/ListLegend.vue';
import { IHistoryState, store } from '@/store/modules/history/types';
import './styles/history-table.scss';
import HistoryMap from './components/HistoryMap/HistoryMap.vue';
import HistoryDetails from './components/HistoryDetails/HistoryDetails.vue';

@Component({
  components: {
    ListLegend,
    HistoryMap,
    HistoryDetails
  }
})
export default class HistoryTable extends Mixins(Utils) {
  @store.Getter
  private getHistoryState!: IHistoryState;

  @store.Getter
  private getHistory!: InlineResponse200;

  private mapModal = false;

  private detailsModal = false;

  private mapMarker: number[] = [];

  private selectedHistory: HistoryInner = {};

  private legends = [
    '',
    'device.history.legends.date',
    'device.history.legends.device_id',
    'device.history.legends.dtco_id',
    'device.history.legends.device_type',
    'device.history.legends.operation_type',
    'device.history.legends.category',
    'device.history.legends.additional_information',
    'device.history.legends.associated_vehicle',
    ''
  ];

  private tableLegends = this.legends.map(legend => ({
    label: legend
  }));

  private legendsFlexStructure = [
    '0 0',
    '0 0 84px',
    '2 1 0',
    '2 1 0',
    '0 0 100px',
    '2 1 0',
    '2 1 0',
    '3 1 45px',
    '0 0 140px',
    '0 0 12px'
  ];

  private formatCategoryToCategoryKey(category: string, seprator: string) {
    return category.toLowerCase().replace('-', seprator);
  }

  private displayMapModal(history: HistoryInner) {
    this.selectedHistory = history;
    if (history.latitude && history.longitude) {
      this.mapMarker = [history.latitude / 10000000, history.longitude / 10000000];
    }
    this.mapModal = !this.mapModal;
  }

  private displayDetailsModal(history: HistoryInner) {
    this.selectedHistory = history;
    this.detailsModal = !this.detailsModal;
  }
}
</script>
